import { useCallback, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
// import { CustomWizardFormProps } from '../../../../../Types/Forms.type';
import BusinessNavComponent from './BusinessNavComponent';
import BusinessTabContent from './BusinessTabContent';
import { H1, H2 } from '../../../../../AbstractElements';

export default function BusinessWizard({ title, divClass, navColClass, tabColClass }: any) {
    const [steps, setSteps] = useState(1);
    const activeCallBack = useCallback((tab: number) => {
        setSteps(tab);
    }, []);

    return (
        <Col sm={12}>
            <Card> {/* Add background color */}
                <div className="d-flex align-items-center mt-4" style={{ marginLeft: '23px' }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/fintrack_logo.png`}
                        alt="Fintrack Logo"
                        style={{ maxWidth: '180px', height: 'auto', marginRight: '10px' }} // Adjust spacing between logo and heading
                    />
                    <H2 className="f-w-800 text-left mt-2 heading-color">Fact Find</H2>
                </div>

                <CardBody>
                    <div className={`horizontal-wizard-wrapper vertical-variations ${divClass ? divClass : ''}`}>
                        <Row className="g-3">
                            <div className={`main-horizontal-header ${navColClass}`}>
                                <BusinessNavComponent activeCallBack={activeCallBack} steps={steps} />
             {/* Sonia's fact find introduction.
                 The old src pointed at /img/Fact_find_video.mp4, which stopped existing when the
                 site moved to Cloudflare Pages - that folder is gone, so the URL quietly returned
                 the homepage HTML and every client saw a dead player at the fact find step.
                 The file now lives in the deploy folder at /video/, and preload="none" keeps a
                 15MB download off the page until somebody actually presses play. */}
             <video width="100%" height="auto" controls preload="none" playsInline
                    poster="https://fintrack.com.au/video/fact-find-poster.jpg"
                    style={{ marginTop: '10px', borderRadius: '8px' }}>
                                <source src="https://fintrack.com.au/video/fact-find-intro.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <p style={{ 
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: '15px'
                            }}>NEXT STEP-FACT FIND</p>
                            <div style={{ 
                                backgroundColor: 'yellow',
                                padding: '8px',
                                borderRadius: '4px',
                                marginTop: '10px',
                                fontWeight: 'bold',
                                fontSize: '20px'
                            }}>
                              Feedback
                              Any questions use the chat bot 
                              or email{' '}
                              <a 
                                href="mailto:help@fintrack.com.au" 
                                style={{ 
                                    color: 'blue', 
                                    textDecoration: 'underline',
                                    fontWeight: 'inherit',
                                    fontSize: 'inherit'
                                }}
                              >
                                help@fintrack.com.au
                              </a>
                             </div>
                            </div>
                            <div className={tabColClass}>
                                <BusinessTabContent steps={steps} activeCallBack={activeCallBack} />
                            </div>
                          
                        </Row>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
}
